import { ReactElement, cloneElement, useId } from 'react'
import { labelClass } from '../../lib/utils'

interface FieldProps {
  label: string
  /** A single form control; it receives the generated id. */
  children: ReactElement<{ id?: string; className?: string }>
  hint?: string
  required?: boolean
  className?: string
}

/** Label + control + hint, so pages stop re-declaring the same three elements. */
export default function Field({ label, children, hint, required, className }: FieldProps) {
  const id = useId()

  return (
    <div className={className}>
      <label htmlFor={id} className={labelClass}>
        {label}
        {required && (
          <span className="ml-1 text-red-500" aria-hidden="true">
            *
          </span>
        )}
      </label>
      {cloneElement(children, { id, className: `mt-1.5 ${children.props.className ?? ''}` })}
      {hint && <p className="mt-1.5 text-xs text-gray-500 dark:text-gray-400">{hint}</p>}
    </div>
  )
}
